module.exports = __webpack_public_path__ + "static/img/img-features-feature-3-list-cn-m@2x.26e0ef9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/img-features-feature-3-list-cn-m@2x.png
// module id = W+QQ
// module chunks = 18